import { render, staticRenderFns } from "./StandardLayout.vue?vue&type=template&id=0f2ec595&scoped=true"
import script from "./StandardLayout.vue?vue&type=script&lang=ts"
export * from "./StandardLayout.vue?vue&type=script&lang=ts"
import style0 from "./StandardLayout.vue?vue&type=style&index=0&id=0f2ec595&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2ec595",
  null
  
)

export default component.exports